import { type ProgramListEvent, createProgramListEvent } from 'models';
import { useQuery } from 'query';
import type { CursorPaginationRailsParams } from 'common/services';
import type { ProgramListEventDataObject } from 'models/service';
import { getEvents } from '../../services';
import type { EventsListFilter } from '../../types';
import { getEventsQueryKey } from '../keys';
import { useGetEventsParameters } from './hooks';

type P = {
  filter?: Omit<EventsListFilter, 'organizationId' | 'scope'>;
  pagination?: CursorPaginationRailsParams;
};

export const useEventsQuery = ({ filter, pagination }: P) => {
  const getEventsParameters = useGetEventsParameters();

  return useQuery<ProgramListEvent[]>({
    async queryFn() {
      const { data: eventContenObject } = await getEvents<ProgramListEventDataObject[]>({
        config: {
          params: getEventsParameters({ filter, pagination }),
        },
      });

      return eventContenObject.map((event) => createProgramListEvent(event));
    },
    queryKey: getEventsQueryKey({ filter }),
  });
};
